module.exports = __webpack_public_path__ + "27212e06dac07ed07174fd25097bd8ac.ttf";